import {
  OccursInExtra,
  ServiceCheckUsageDetailedModel,
  ServiceCheckUsageModel
} from '@aipb/personal-content/shared/model';
import { isEmpty } from '@aipb/util/other';
import { Injectable } from '@angular/core';
import { filter, Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ServiceApiService } from '../../api';
import { FavoriteLibRepository } from './favorite-lib.repository';

@Injectable({
  providedIn: 'root'
})
export class FavoriteLibService {
  private _refreshPlugin = new Subject<void>();
  refreshPlugin$ = this._refreshPlugin.asObservable();

  constructor(private api: ServiceApiService, private repository: FavoriteLibRepository) {}

  refreshPlugin() {
    this._refreshPlugin.next();
  }

  getFavorites(service: string, serviceValues: string[]): Observable<[ServiceCheckUsageModel, string[]]> {
    return this.api
      .checkUsage({
        service: service,
        serviceValue: serviceValues
      })
      .pipe(
        filter((data) => !!data),
        // @ts-expect-error foo
        map((data) => {
          let ids: string[] = [];

          if (data.owns && data.owns.favorites) {
            ids = [...ids, ...data.owns.favorites];
          }

          if (data.owns && data.owns.general) {
            ids = [...ids, ...data.owns.general];
          }

          if (data.owns && data.owns.didactic) {
            ids = [...ids, ...data.owns.didactic];
          }

          if (data.others && data.others.favorites) {
            ids = [...ids, ...data.others.favorites];
          }

          if (data.others && data.others.general) {
            ids = [...ids, ...data.others.general];
          }

          if (data.others && data.others.didactic) {
            ids = [...ids, ...data.others.didactic];
          }

          return [data, ids];
        }),
        tap((data: [ServiceCheckUsageModel, string[]]) => {
          const serviceCheckUsage: ServiceCheckUsageModel = data[0];
          const ids: string[] = data[1];

          const d: {
            [key: string]: OccursInExtra;
          } = {};

          serviceValues.forEach((serviceValue) => {
            if (ids.some((id) => id === serviceValue)) {
              const key = Object.keys(serviceCheckUsage?.nibbleRelations || {}).find((sv) => sv === serviceValue);
              const hasRelatedNibbles: boolean = key ? serviceCheckUsage.nibbleRelations[key] : false;

              d[serviceValue] = {
                hasRelatedNibbles: hasRelatedNibbles,
                ownFavorites: serviceCheckUsage?.owns?.favorites?.some((sv) => sv === serviceValue) || false,
                ownCollections:
                  serviceCheckUsage?.owns?.general?.some((sv) => sv === serviceValue) ||
                  serviceCheckUsage?.owns?.didactic?.some((sv) => sv === serviceValue) ||
                  false,
                otherCollections:
                  serviceCheckUsage?.others?.favorites?.some((sv) => sv === serviceValue) ||
                  serviceCheckUsage?.others?.general?.some((sv) => sv === serviceValue) ||
                  serviceCheckUsage?.others?.didactic?.some((sv) => sv === serviceValue) ||
                  false
              };
            } else {
              d[serviceValue] = {
                hasRelatedNibbles: false,
                ownFavorites: false,
                ownCollections: false,
                otherCollections: false
              };
            }
          });

          this.repository.setServiceData(service, d);
        })
      );
  }

  getFavorite(service: string, serviceValue: string): Observable<ServiceCheckUsageDetailedModel> {
    return this.api
      .checkUsageDetailed({
        service: service,
        serviceValue: serviceValue
      })
      .pipe(
        filter((data) => !!data),
        tap((data) => {
          const hasRelatedNibbles = data.nibbleRelations && !isEmpty(data.nibbleRelations);
          this.repository.setServiceValueData(service, serviceValue, data.occursIn, hasRelatedNibbles);
        })
      );
  }
}
